<template>
  <article class="pressItem">
    <header>
      <a class="img" v-if="item.link" :style="imgStyle" :href="item.link" target="_blank"></a>
      <div class="img" v-else :style="imgStyle"></div>
      <p class="meta">{{ formattedPubDate }}</p>
      <h4>
        <a v-html="item.headline" v-if="item.link" :href="item.link" target="_blank"></a>
        <span v-html="item.headline" v-else></span>
      </h4>
    </header>
    <p>
      <span v-html="item.excerpt"></span> [...]
      <a class="more-link" v-if="item.link" :href="item.link" target="_blank">More</a>
    </p>
  </article>
</template>

<script>
export default {
  name: 'press-item',
  props: ['item'],
  computed: {
    imgStyle () {
      return {
        backgroundImage: `url(${this.logo})`
      }
    },
    logo () {
      let image = this.item.logo.sizes.medium
      if (process.env.NODE_ENV === 'development') {
        image = image.replace('http://longestshortesttime.duck/app', 'http://cdn.longestshortesttime.com/wp-content')
      }
      return image
    },
    formattedPubDate () {
      let vm = this
      if (vm.item.publish_date) return vm.$moment(vm.item.publish_date).format('MM.DD.YY')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
  @import ../../assets/styles/colors
  @import ../../assets/styles/mixins

  .pressItem
    text-align: center
    +until($tablet)
      padding: 30px
      margin-bottom: 30px
    +tablet
      margin-bottom: 50px
      width: 46.5%
      margin-right: 7%
      &:nth-child(2n)
        margin-right: 0
    header
      position: relative
      .img
        display: block
        width: 172px
        height: 94px
        background: #fff
        background-size: cover
        background-position: 50% 50%
        border: 1px solid #95989A
        margin: 0 auto 4px
        position: relative
        z-index: 1
      a.img
        &:hover
          filter: brightness(110%)
      &:before
        content: ''
        position: absolute
        width: 100%
        left: 0
        top: 47px
        border-top: 1px solid #95989A
      .meta
        font-weight: bold
        margin-bottom: 10px
      h4
        font-size: 22px
        font-weight: bold
        line-height: 26px
        margin-bottom: 15px
    a
      color: inherit
      &:hover
        color: lighten($textColor, 25%)
    p
      font-size: 18px
      line-height: 30px
</style>



// WEBPACK FOOTER //
// PressItem.vue?7fd08d47